import { render, staticRenderFns } from "./DnPublicationStatistics.vue?vue&type=template&id=9872c740&scoped=true&"
import script from "./DnPublicationStatistics.vue?vue&type=script&lang=js&"
export * from "./DnPublicationStatistics.vue?vue&type=script&lang=js&"
import style0 from "./DnPublicationStatistics.vue?vue&type=style&index=0&id=9872c740&lang=scss&scoped=true&"
import style1 from "./DnPublicationStatistics.vue?vue&type=style&index=1&id=9872c740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9872c740",
  null
  
)

export default component.exports